import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export type KeyRadioStationProps = { id: number };

export const keyRadioStation: BaseKeyFunction<KeyRadioStationProps> = ({
  id,
}) => ["radio-station", id?.toString()];
